import { jasBoardVerificationHistoryEntityName } from '../entities/jas-board-verification-history/jasBoardVerificationHistory';
export function getJasBoardVerificationHistoryStorage(context) {
    return context.storage(jasBoardVerificationHistoryEntityName);
}
